//the initialize
angular.module('clickactionModule', ['ui.bootstrap', 'ttcmExtensionsModule', 'cacheManagerModule','rememberModule','layoutModule'])
    .service('clickactionService', ['$q', 'cacheManagerService', clickactionService])
    .controller('clickactionController', ['$q', '$scope', 'ttcmExtensionsService', 'clickactionService','layoutService', 'rememberFactory', clickactionController]);
